import React, { Component } from "react";
import { DKLabel, DKButton } from "deskera-ui-library";
import LandingPageManager from "../landing_pages/LandingPageManager";
import { FUNNEL_TYPE } from "./FunnelManager";
import FormManager from "../forms/FormManager";

class TemplateSelectionPopup extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <div className="transparent-background">
        <div className="popup-window" style={{ padding: 26, minWidth: 680 }}>
          <div className="row justify-content-between align-items-start">
            <div>
              <DKLabel text="Select template" className="fw-m fs-l" />
              <DKLabel
                text="Select a funnel template, you can change and modify it later"
                className="text-gray mt-xs"
              />
            </div>
            <div className="row" style={{ width: "auto" }}>
              <DKButton
                title="Cancel"
                className="bg-gray1 border-m ml-xxl"
                onClick={() => {
                  this.props.onCancel();
                }}
              />
              {/* <DKButton
                title="Save"
                className="bg-app text-white border-m ml-r"
              /> */}
            </div>
          </div>
          <div className="row flex-wrap mt-xl pb-m" style={{ gap: 25 }}>
            {this.getAllTemplates()}
          </div>
        </div>
      </div>
    );
  }

  getAllTemplates() {
    const templates =
      this.props.funnelType === FUNNEL_TYPE.COLLECT_EMAIL
        ? FormManager.getAllTemplates()
        : LandingPageManager.getAllTemplates();
    return templates.map((img, index) => {
      return (
        <div
          className="border-m  cursor-hand"
          style={{ width: 135 }}
          onClick={() => {
            this.props.onTemplateSelect(index);
          }}
        >
          <img src={img} alt="" className="parent-width" />
        </div>
      );
    });
  }
}

export default TemplateSelectionPopup;
